// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__35y0m","question":"Question_question__3d611","description":"Question_description__37KBc"};